module.exports = __webpack_public_path__ + "static/daniel-funes-fuentes-TyLw3IQALMs-unsplash-f5e5f845a92133038784d788653ba5f3.jpg";